import i18n from '../locales/i18n';

/**
 * Normalizes dotted invalid keys so array indexes map to i18n wildcards (films.0.title → films.*.title).
 */
export function normalize_import_invalid_key(key) {
    return key.replaceAll(/\.\d+/gm, '.*');
}

function first_existing_key(candidates) {
    for (const key of candidates) {
        if (key && i18n.exists(key))
            return key;
    }
    return null;
}

/**
 * User-facing label for an engine invalid field path (e.g. cinema_hall → Salle).
 */
export function translate_import_invalid_field_label(resource, key) {
    const normalized = normalize_import_invalid_key(key);
    const leaf = normalized.includes('.') ? normalized.split('.').pop() : normalized;
    const translation_key = first_existing_key([
        `common.import_fields.${normalized}`,
        `common.import_fields.${leaf}`,
        `${resource}.import_fields.${normalized}`,
        `${resource}.import_fields.${leaf}`,
        normalized === 'cinema_hall' ? `${resource}.place` : null,
    ]);
    if (translation_key)
        return i18n.t(translation_key);
    return key;
}

/**
 * Resolves the i18n key for an import validation message (with optional Eventival variants).
 */
export function resolve_import_invalid_message_key(resource, key, code, options = {}) {
    const normalized = normalize_import_invalid_key(key);
    const { importSource, eventivalKind } = options;

    if (resource === 'screenings' && key === 'cinema_hall' && (code === 'EISNOTOBJ' || code === 'ENOPROP')) {
        const is_event = importSource === 'eventival' && eventivalKind === 'event';
        const suffix = is_event ? '_event' : '';
        const specific = `${resource}.invalid.${normalized}.${code}${suffix}`;
        if (i18n.exists(specific))
            return specific;
    }

    return first_existing_key([
        `${resource}.invalid.${normalized}.${code}`,
        `common.validation.${code}`,
    ]) || code;
}

/**
 * User-facing message for an engine validation code on a field path.
 */
export function translate_import_invalid_message(resource, key, code, options = {}) {
    const translation_key = resolve_import_invalid_message_key(resource, key, code, options);
    if (translation_key && i18n.exists(translation_key))
        return i18n.t(translation_key);
    return code;
}
